module.exports = __webpack_public_path__ + "img/weihudashi.14979e3f.png";